import { render, staticRenderFns } from "./ApexDonutChartDomain.vue?vue&type=template&id=8324c65a&"
import script from "./ApexDonutChartDomain.vue?vue&type=script&lang=js&"
export * from "./ApexDonutChartDomain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports